import React from 'react';
import Icon from '.';

const ChevronRightIcon = props => (
	<Icon {...props} viewBox="0 0 6.519043 9.4750977">
		<polygon
			fill="currentColor"
			points="1.3515625,9.4750977 0,8.0004883 3.5595703,4.7373047 0,1.4746094 1.3515625,0 6.519043,4.7373047 "
		/>
	</Icon>
);

export default ChevronRightIcon;
